let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7WVoE")).then(() => parcelRequire('gHgDK'));